module.exports = __webpack_public_path__ + "static/media/edit-icon-profile.18925433.svg";